<div class="wrapper row2">
  <div id="container" class="clear">
    <nz-alert nzType="error" *ngFor="let msg of messages"
      [nzDescription]="msg.detail"
      [nzMessage]="msg.summary"></nz-alert>
  </div>
</div>
